
import { DarkModeToggle } from "./toggleButtons";
import { useWindowDimensions } from "./useWindowDimension";




export const PhoneBar = ({
  active,
  setActive,
  darkMode,
  setDarkMode,
  setManualScroll,
  setPopup
}) => {





  return (
    <div
      style={{ height: `${useWindowDimensions().height}px` }}
      className={`fixed top-0 left-0 z-10 w-full   ${
        darkMode ? "bg-[#181a1b] text-white " : "bg-white text-black"
      }`}
    >
      <div
        className={`h-full font-serif flex flex-col  text-gray-600 text-xl  justify-center items-center  gap-10 `}
      >
        <a
          href="#Profile"
          onClick={() => {
            setPopup(false);
            setManualScroll(true);
            setActive("profile");
          }}
          className={`${
            active === "profile" &&
            `border-b-2 border-red-400 pb-1   ${
              darkMode ? "text-white" : "text-black"
            }`
          } `}
        >
          Profile
        </a>
        <a
          href="#Projects"
          onClick={() => {
            setPopup(false);
            setManualScroll(true);
            setActive("project");
          }}
          className={`${
            active === "project" &&
            `border-b-2 border-red-400 pb-1   ${
              darkMode ? "text-white" : "text-black"
            }`
          } `}
        >
          Projects
        </a>
        <a
          href="#Contact"
          onClick={() => {
            setPopup(false);
            setManualScroll(true);
            setActive("contact");
          }}
          className={`${
            active === "contact" &&
            `border-b-2 border-red-400 pb-1   ${
              darkMode ? "text-white" : "text-black"
            }`
          } `}
        >
          Contact
        </a>
        <DarkModeToggle darkMode={darkMode} setDarkMode={setDarkMode} />
      </div>
    </div>
  );
};